<app-feature-tiles-grid *ngIf="this.device$ | async as device">
  <ng-container [ngSwitch]="device.status">
    <app-notification-tile *ngSwitchCase="DeviceStatusType.Offline"></app-notification-tile>
    <ng-container *ngSwitchDefault>
      <app-device-features-container
        [header]="'+INSTALLATIONS.INSTALLATION.PHOTOVOLTAICS.TITLE' | translate"
        [overlayType]="FeaturesDetailsOverlayTypeEnum.SolarLog"
        [deviceSelectId]="device.selectId"
      >
        <app-feature-tile
          *ngrxLet="solarLogState$ | async | ready as feature"
          data-at-photovoltaic-status
          feature
          [label]="'+INSTALLATIONS.INSTALLATION.SOLARLOG.STATUS' | translate"
          [value]="feature | value2: featurePropertyKey.status | translatePhotovoltaicState"
          [attr.data-feature]="feature?.feature"
          isFullWidth="true"
        ></app-feature-tile>

        <!-- photovoltaic.production.current -->
        <app-feature-tile
          *ngrxLet="currentProduction$ | async | ready as feature"
          data-at-photovoltaic-current-production
          feature
          [error]="feature | error"
          [label]="'+INSTALLATIONS.INSTALLATION.SOLARLOG.PRODUCTION' | translate"
          value="{{ feature | value2: featurePropertyKey.value }} {{ feature | unit: 'value' }}"
          [attr.data-feature]="feature?.feature"
          isFullWidth="true"
        ></app-feature-tile>
      </app-device-features-container>
    </ng-container>
  </ng-container>
</app-feature-tiles-grid>
